<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Product" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Product</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Product ID *" v-model="data.product_code" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Description *" v-model="data.description_1" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" v-model="data.description_2" />
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Client *</label>
                                <v-select
                                    :options="clientsOptions"
                                    v-model="data.client_id"
                                    :reduce="client => client.id"
                                    label="client_code"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Product Category *</label>
                                <v-select
                                    :options="productcategoryOptions"
                                    v-model="data.product_categories_id"
                                    label="name"
                                    :reduce="product_categories_id => product_categories_id.id"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <label for class="vs-input--label">Status</label>
                                <vs-switch class="mt-2" v-model="data.is_active">
                                    <span slot="on">Active</span>
                                    <span slot="off">Deactive</span>
                                </vs-switch>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-6">
                    <vs-tab label="Unit of Measure">
                        <div class="vx-row mt-8">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Base UoM *</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="UomOption"
                                            v-model="default_uom.uom_id"
                                            label="name"
                                            :reduce="uom_id => uom_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Base Volume</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2 sm:mb-1">
                                                <vs-input class="w-full" v-model="default_uom.base_volume" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <v-select
                                                    :options="UomVolume"
                                                    v-model="default_uom.uom_volume_id"
                                                    label="name"
                                                    :reduce="uom_volume_id => uom_volume_id.id"
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Base Gross Weight</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2 sm:mb-1">
                                                <vs-input class="w-full" v-model="default_uom.base_gw" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <v-select
                                                    :options="UomWeight"
                                                    v-model="default_uom.uom_gw_id"
                                                    label="name"
                                                    @input="changeUomWeight()"
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Base Net Weight</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2 sm:mb-1">
                                                <vs-input class="w-full" v-model="default_uom.base_nw" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <v-select
                                                    :options="UomWeight"
                                                    v-model="default_uom.uom_nw_id"
                                                    label="name"
                                                    :disabled="true"
                                                ></v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Barcode</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="default_uom.barcode" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Dimension</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="default_uom.dimension" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <vs-divider border-style="solid" class="mt-8">PRODUCT UOM</vs-divider>
                        <div class="vx-row">
                            <div class="vx-col w-full mb-4">
                                <vs-button
                                    color="primary"
                                    size="sm"
                                    class="btn mb-4 md:mb-0 mr-1"
                                    @click="addUom"
                                >Add</vs-button>
                                <vs-button
                                    color="primary"
                                    size="sm"
                                    class="btn mb-4 md:mb-0"
                                    @click="removeUom"
                                    :disabled="uom_selected.length <= 0"
                                >Remove</vs-button>
                            </div>
                            <div class="vx-col w-full">
                                <vs-table v-model="uom_selected" :data="uom_list" stripe multiple hoverFlat>
                                    <template slot="thead">
                                        <vs-th>Uom</vs-th>
                                        <vs-th>Numerator</vs-th>
                                        <vs-th>Denominator</vs-th>
                                        <vs-th>Barcode</vs-th>
                                        <vs-th>Dimension</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td>
                                                <vs-select v-model="tr.uom_id" width="100%">
                                                    <vs-select-item
                                                        v-for="(item, index) in UomOption"
                                                        :key="index"
                                                        :value="item.id"
                                                        :text="item.name"
                                                    />
                                                </vs-select>
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.numerator" />
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.denominator" />
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.barcode" />
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.dimension" />
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="WM Configuration">
                        <div class="vx-row mt-8">
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Storage Quantity</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="vm_config.storage_quantity" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="vm_config.storage_quantity_1"
                                                    :disabled="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Replenish Quantity</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="vm_config.replenish_quantity" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="vm_config.replenish_quantity_1"
                                                    :disabled="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Minimum Quantity</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="vm_config.minimum_quantity" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="vm_config.minimum_quantity_1"
                                                    :disabled="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Maximum Quantity</div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/2">
                                                <vs-input class="w-full" v-model="vm_config.maximum_quantity" />
                                            </div>
                                            <div class="vx-col w-1/2">
                                                <vs-input
                                                    class="w-full"
                                                    v-model="vm_config.maximum_quantity_1"
                                                    :disabled="true"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="vx-col lg:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Default Location Type ID</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="defaultLocationTypesOption"
                                            v-model="vm_config.default_location_type_id"
                                            label="code"
                                            :reduce="default_location_type_id => default_location_type_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">CAB Location ID</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="vm_config.cab_location_id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Pick Location ID</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="vm_config.pick_location_id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">BULK Location ID</div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="vm_config.bulk_location_id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Section</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="sectionOption"
                                            v-model="vm_config.section_id"
                                            label="section_code"
                                            :reduce="section_id => section_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Put Strategy</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="putOption"
                                            v-model="vm_config.put_strategy_id"
                                            label="name"
                                            :reduce="put_strategy_id => put_strategy_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/3">Pick Strategy</div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="pickOption"
                                            v-model="vm_config.pick_strategy_id"
                                            label="name"
                                            :reduce="pick_strategy_id => pick_strategy_id.id"
                                            :clearable="false"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="VAS">
                        <div class="vx-row mt-8">
                            <div class="vx-col w-full mb-4">
                                <vs-button
                                    color="primary"
                                    size="sm"
                                    class="btn mb-4 md:mb-0 mr-1"
                                    @click="addProductVas"
                                    :disabled="!this.data.client_id"
                                >Add</vs-button>
                                <vs-button
                                    color="primary"
                                    size="sm"
                                    class="btn mb-4 md:mb-0"
                                    @click="removeProductVas"
                                    :disabled="product_vas_selected.length <= 0"
                                >Remove</vs-button>
                            </div>
                            <div class="vx-col w-full">
                                <vs-table v-model="product_vas_selected" :data="product_vas" stripe multiple hoverFlat>
                                    <template slot="thead">
                                        <vs-th>Product ID</vs-th>
                                        <vs-th>Description</vs-th>
                                        <vs-th>Base Qty</vs-th>
                                        <vs-th>Base Unit</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                            <vs-td>
                                                <vs-select v-model="tr.product_id" @input="changeProductVas(tr)">
                                                <vs-select-item
                                                    v-for="(item, index) in productOption"
                                                    :key="index"
                                                    :value="item"
                                                    :text="item.product_code"
                                                />
                                                </vs-select>
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.base_qty" />
                                            </vs-td>
                                            <vs-td>
                                                <vs-input class="w-full" v-model="tr.base_unit" :disabled="true"/>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Manufacturing"></vs-tab>
                    <vs-tab label="Notes"></vs-tab>
                    <vs-tab label="Attachment"></vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script>
    import vSelect from "vue-select";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";

    export default {
        components: {
            vSelect,
            flatPickr
        },
        data() {
            return {
                isLoading: false,
                data: {
                    is_active: true,
                    product_code: "",
                    description_1: "",
                    description_2: "",
                    client_id: null,
                    product_categories_id: null
                },
                default_uom:{
                    uom_id:null,
                    base_volume:0,
                    uom_volume_id:null,
                    base_nw:0,
                    uom_nw_id:null,
                    base_gw:0,
                    uom_gw_id:null,
                    barcode:'',
                    dimension:'',
                },
                vm_config: {
                    storage_quantity: 0,
                    replenish_quantity: 0,
                    minimum_quantity: 0,
                    maximum_quantity: 0,

                    storage_quantity_1: "",
                    replenish_quantity_1: "",
                    minimum_quantity_1: "",
                    maximum_quantity_1: "",

                    default_location_type_id: null,
                    cab_location_id: 0,
                    pick_location_id: 0,
                    bulk_location_id: 0,
                    section_id: null,
                    // section_id:this.$store.state.user.userconfig.section,
                    put_strategy_id: null,
                    pick_strategy_id: null
                },
                product_vas:[],
                product_vas_selected:[],
                uom_list: [],
                uom_selected: [],
                UomOption: [],
                UomVolume: [],
                UomWeight: [],
                defaultLocationTypesOption: [],
                clientsOptions: [],
                productcategoryOptions: [],
                productOption: [],
                sectionOption: [],
                pickOption: [],
                putOption: [],
            };
        },
        watch: {
            isLoading: function() {
                if (this.isLoading){
                    this.$vs.loading();
                }
                else{
                    this.$vs.loading.close();
                }
            }
        },
        methods: {
            changeProductVas(data){
                data.description = data.product_id.description_1
                data.base_unit = data.product_id.base_uom.uom.name
            },
            removeProductVas(){
                this.product_vas_selected.map((item1, index1) => {
                    this.product_vas.map((item, index) => {
                        if(item == item1) {
                            this.product_vas.splice(index, 1);
                        }
                    });
                });
                this.product_vas_selected = [];
            },
            addProductVas(){
                const add = () => {
                    this.product_vas.push({
                        product_id: null,
                        description: '',
                        base_qty: 0,
                        base_unit: ''
                    });
                }

                if(!this.productOption.length) {
                    this.isLoading = true;
                    this.$http.post('master/product/showbyclient', { client_id: this.data.client_id })
                    .then(res => {
                        this.productOption = res.data.data;
                        add();
                        this.isLoading = false;
                    })
                }
                else {
                    add();
                }
            },
            changeUomWeight(){
                this.default_uom.uom_nw_id = this.default_uom.uom_gw_id
            },
            addUom() {
                let obj = {
                    uom_id: null,
                    numerator: 0,
                    denominator: 0,
                    barcode: 0,
                    dimension: 0,
                    status: "insert"
                };
                this.uom_list.push(obj);
            },
            removeUom() {
                this.$vs.dialog({
                    type: "confirm",
                    color: "danger",
                    title: "Remove Data ?",
                    text: "Are you sure want to remove selected data ?",
                    accept: () => {
                        this.uom_selected.map((item1, index1) => {
                            this.uom_list.map((item, index) => {
                                if (item == item1) {
                                    this.uom_list.splice(index, 1);
                                }
                            });
                        });
                        this.uom_selected = [];
                    },
                    cancel: () => {
                        return;
                    },
                    acceptText: "Yes",
                    cancelText: "No"
                });
            },
            fetchData(api) {
                return this.$http.get(api);
            },
            submitForm() {
                this.isLoading = true;

                const data = {
                    product_code: this.data.product_code,
                    description_1: this.data.description_1,
                    description_2: this.data.description_2,
                    client_id: this.data.client_id,
                    product_categories_id: this.data.product_categories_id,
                    is_active: this.data.is_active,
                    base_uom: {
                        base_uom_id: this.default_uom.uom_id,
                        base_volume: this.default_uom.base_volume,
                        base_volume_id: this.default_uom.uom_volume_id,
                        base_gross_weight: this.default_uom.base_gw,
                        base_net_weight: this.default_uom.base_nw,
                        base_gross_weight_id: this.default_uom.uom_gw_id ?  this.default_uom.uom_gw_id.id : null,
                        barcode: this.default_uom.barcode,
                        dimension: this.default_uom.dimension,
                    },
                    vm_configuration: {
                        storage_quantity: this.vm_config.storage_quantity,
                        replenish_quantity: this.vm_config.replenish_quantity,
                        minimum_quantity: this.vm_config.minimum_quantity,
                        maximum_quantity: this.vm_config.maximum_quantity,
                        default_location_type_id: this.vm_config.default_location_type_id,
                        cab_location_id: this.vm_config.cab_location_id,
                        pick_location_id: this.vm_config.pick_location_id,
                        bulk_location_id: this.vm_config.bulk_location_id,
                        section_id: this.vm_config.section_id,
                        put_strategy_id: this.vm_config.put_strategy_id,
                        pick_strategy_id: this.vm_config.pick_strategy_id
                    },
                    product_uoms: this.uom_list,
                    product_boms: this.product_vas.map(i => {
                        return {
                            product_id: i.product_id.id,
                            base_qty: i.base_qty
                        }
                    }),
                };

                this.$http.post("master/product/store", data)
                .then(res => {                    
                    this.isLoading = false;

                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: res.data.message || 'Success'
                    });

                    this.$router.push({
                        name: "master-product-view",
                        params: {
                            id: res.data.id
                        }
                    });
                })
                .catch(error => this.handleError(error))
            },
            back() {
                if (
                    this.data.product_code != "" ||
                    this.data.description_1 != "" ||
                    this.data.description_2 != "" ||
                    this.data.client_id != "" ||
                    this.product_categories_id != ""
                ) {
                    this.$vs.dialog({
                        color: "warning",
                        title: "Leave Page",
                        text: "Changes you made may not be saved?",
                        acceptText: "Leave Page",
                        accept: () => this.$router.go(-1)
                    });
                } else {
                    this.$router.go(-1);
                }
            },
            fetchAllData() {
                this.isLoading = true;
                this.$http.all([
                    this.$http.post("master/clients"),
                    //this.$http.post("master/productcategories"),
                    this.$http.post("master/productcategorieslov"),
                    this.$http.post("master/uom"),
                    this.$http.post('master/uov'), 
                    this.$http.post('master/uow'), 
                    this.$http.post("master/locationtypes"),
                    this.$http.post("master/sections"),
                    this.$http.get("master/movementstrategygetpick"),
                    this.$http.get("master/movementstrategygetput")
                ])
                .then(this.$http.spread((clients,productcategories,uoms,uovs,uows,locationtypes,sections,mospick,mosput) => {
                    this.clientsOptions = clients.data.data;
                    this.productcategoryOptions = productcategories.data.data;

                    this.UomOption = uoms.data.data;
                    this.UomVolume = uovs.data.data
                    this.UomWeight = uows.data.data

                    this.defaultLocationTypesOption = locationtypes.data.data;
                    this.sectionOption = sections.data.data;
                    this.putOption = mosput.data;
                    this.pickOption = mospick.data;
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                }))
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.fetchAllData();
                        },
                        cancel: () => this.$router.go(-1),
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
            },
        },
        mounted() {
            this.fetchAllData();
        }
    }
</script>